import { USERS } from '../../../firebase';
import {
  brrrrCriteria,
  purchaseCriteria,
  buyAndHoldCriteria,
} from './formSections';

export default {
  layoutClasses: '',
  pathToSource: [
    {
      type: 'collection',
      value: USERS,
    },
    {
      type: 'user',
      value: 'uid',
    },
  ],
  inputs: {
    title: 'Investment Criteria',
    description:
      'Personalize your investment criteria. The criteria here are global and will be applied to all properties you analyze. They can be overridden on a per-property basis.',
    doNotReset: true,
    schema: [purchaseCriteria, buyAndHoldCriteria, brrrrCriteria],
  },
};
